import { motion } from "framer-motion";
import { MapPin, Globe, Wifi, Phone } from "lucide-react";

const coverageAreas = [
  {
    icon: MapPin,
    title: "Domestic Coverage",
    items: [
      "All 50 US states with multi-carrier redundancy",
      "Automatic switching between Verizon, AT&T, T-Mobile, US Cellular",
      "Rural and remote area specialization",
      "Urban fiber alternatives"
    ]
  },
  {
    icon: Globe,
    title: "International Reach",
    items: [
      "200+ countries worldwide",
      "800+ carrier network relationships",
      "Multi-IMSI global SIM technology",
      "Unified international management"
    ]
  },
  {
    icon: Wifi,
    title: "Technology Portfolio",
    items: [
      "4G LTE, 5G, and legacy network support",
      "Satellite connectivity (Starlink, GEO, LEO)",
      "SD-WAN and WAN bonding architectures",
      "Legacy system support (POTS, analog)"
    ]
  }
];

export const HomeCoverage = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Global Coverage, Local Expertise
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {coverageAreas.map((area, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="bg-white/5 backdrop-blur-sm p-8 rounded-xl border border-white/10 hover:bg-white/10 transition-all"
            >
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-primary to-primary/60 flex items-center justify-center mb-6 shadow-lg">
                <area.icon className="w-7 h-7 text-white" />
              </div>

              <h3 className="text-2xl font-bold mb-6">{area.title}</h3>

              <ul className="space-y-3">
                {area.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-white/80">
                    <span className="text-primary mt-1 text-xl">•</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* Stats Row */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="grid grid-cols-2 md:grid-cols-4 gap-6"
        >
          {[
            { value: "50", label: "US States" },
            { value: "200+", label: "Countries" },
            { value: "800+", label: "Networks" },
            { value: "24/7", label: "Support" }
          ].map((stat, index) => (
            <div key={index} className="text-center p-6 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10">
              <div className="text-4xl font-bold text-primary mb-2">{stat.value}</div>
              <div className="text-white/70">{stat.label}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
